import React, { useContext } from 'react';
import { StageBackgroundProps } from '../types';
import EmptyBackground from '../EmptyBackground';
import { getIsShortStatus } from '../../../DeviationViews/_helpers';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';

export const StatusStageBackground: React.FC<StageBackgroundProps> = ({
  deviation,
}) => {
  const isMobile = useContext(MobileContext);
  const isShortStatus = getIsShortStatus(deviation);
  const { needsSubscription } = useSubscriptionTier(deviation);

  return (!isMobile || isShortStatus) && !needsSubscription ? (
    <EmptyBackground />
  ) : null;
};
StatusStageBackground.displayName = 'StatusStageBackground';

export default StatusStageBackground;
